// extracted by mini-css-extract-plugin
export var component_wrapper_hero = "all-module--component_wrapper_hero--ff6d0";